import '.bu{position:relative;}.ssr-plugin'
import '.x{width:100%;}.ssr-plugin'
import '.g4{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.bt{align-items:flex-start;}.ssr-plugin'
import '.t{padding:2rem;}.ssr-plugin'
import '.cu{background:var(--shades-white);}.ssr-plugin'
import '.p{overflow:hidden;}.ssr-plugin'
import '.l{position:absolute;}.ssr-plugin'
import '.i8{top:50%;}.ssr-plugin'
import '.i9{right:1rem;}.ssr-plugin'
import '.ia{transform:translateY(-50%);}.ssr-plugin'
import '.ib{width:120px;}.ssr-plugin'
import '.ic{height:120px;}.ssr-plugin'
import '.id{z-index:0;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.hh{z-index:1;}.ssr-plugin'
import '.ab{gap:0.5rem;}.ssr-plugin'
import '.ie{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bu x g4 a b g bt t cu p"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="l i8 i9 ia ib ic id a c g"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bu hh a b bt ab ie"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
